import React, { useState } from 'react';
import { modules } from '../mock/data';
import {
  Calendar, Users, FileText, Smartphone, Zap, MessageSquare, MonitorPlay, ArrowRight,
  ShoppingCart, Package, Calculator, UserCog, FolderKanban, Headphones,
  ClipboardList, Fingerprint, Building2, Truck, KeyRound, Laptop
} from 'lucide-react';

const iconMap = {
  Calendar,
  Users,
  FileText,
  MessageSquare,
  MonitorPlay,
  Smartphone,
  Zap,
  ShoppingCart,
  Package,
  Calculator,
  UserCog,
  FolderKanban,
  Headphones,
  ClipboardList,
  Fingerprint,
  Building2,
  Truck,
  KeyRound,
  Laptop
};

const moduleRouteMap = {
  crm: '/crm',
  sales: '/ventas',
  inventory: '/inventario',
  accounting: '/contabilidad',
  hr: '/rrhh',
  projects: '/proyectos',
  helpdesk: '/helpdesk',
  surveyhub: '/surveyhub',
  attendance: '/control-asistencia',
  spaceshub: '/spaceshub',
  logistics: '/logistica',
  meetingroom: '/meetingroom',
  invoicing: '/facturacion',
  accesscontrol: '/control-acceso',
  app: '/app-personalizada',
  automation: '#',
  endpoint: '/cloudbase-endpoint'
};

const ModulesSection = () => {
  const [hoveredModule, setHoveredModule] = useState(null);

  return (
    <section id="modulos" className="py-32 bg-white scroll-mt-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-5xl sm:text-6xl font-bold mb-6 text-gray-900">
            Una Plataforma Integrada
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-light">
            Cada uno de nuestros productos es intuitivo y poderoso por sí solo, pero conectados en una sola plataforma proporcionan capacidades de clase mundial.
          </p>
        </div>

        {/* Modules Grid - Verkada style */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-gray-200 border border-gray-200">
          {modules.map((module, index) => {
            const Icon = iconMap[module.icon];
            return (
              <div
                key={module.id}
                onMouseEnter={() => setHoveredModule(index)}
                onMouseLeave={() => setHoveredModule(null)}
                className="bg-white p-12 hover:bg-gray-50 transition-colors duration-200 cursor-pointer group"
              >
                <div className="mb-6">
                  <Icon className="w-12 h-12 text-gray-900" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {module.name}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {module.description}
                </p>
                <a 
                  href={moduleRouteMap[module.id] || '#'}
                  className="inline-flex items-center gap-2 text-green-600 font-semibold group-hover:gap-3 transition-all"
                  data-testid={`module-link-${module.id}`}
                >
                  Conocer más
                  <ArrowRight className="w-4 h-4" />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ModulesSection;